import { render } from "./RightBarContent.vue?vue&type=template&id=2aa3c73a"
import script from "./RightBarContent.vue?vue&type=script&lang=ts"
export * from "./RightBarContent.vue?vue&type=script&lang=ts"
script.render = render

export default script